import { IconName } from "@quortex/front-common"

export const DefaultPercentageValue = 100
export const DefaultTTLValue = 3000

export const DefaultPageSize = 8

export const iso3166_2ToCoordinates = {
  "US-AK": {
    code: "US-AK",
    division: "state",
    lat: 63.588753,
    lng: -154.4930619,
    name: "Alaska",
    parent: "US"
  },
  "US-AL": {
    code: "US-AL",
    division: "state",
    lat: 32.3182314,
    lng: -86.90229799999997,
    name: "Alabama",
    parent: "US"
  },
  "US-AR": {
    code: "US-AR",
    division: "state",
    lat: 34.2354138,
    lng: -91.28910359999998,
    name: "Arkansas",
    parent: "US"
  },
  "US-AS": {
    code: "US-AS",
    division: "outlying area",
    lat: -14.3064071,
    lng: -170.6950175,
    name: "American Samoa",
    parent: "US"
  },
  "US-AZ": {
    code: "US-AZ",
    division: "state",
    lat: 34.0489281,
    lng: -111.09373110000001,
    name: "Arizona",
    parent: "US"
  },
  "US-CA": {
    code: "US-CA",
    division: "state",
    lat: 34.1270546,
    lng: -117.34108100000003,
    name: "California",
    parent: "US"
  },
  "US-CO": {
    code: "US-CO",
    division: "state",
    lat: 39.5500507,
    lng: -105.78206740000002,
    name: "Colorado",
    parent: "US"
  },
  "US-CT": {
    code: "US-CT",
    division: "state",
    lat: 41.6032207,
    lng: -73.08774900000003,
    name: "Connecticut",
    parent: "US"
  },
  "US-DC": {
    code: "US-DC",
    division: "district",
    lat: 38.8951118,
    lng: -77.0363658,
    name: "District of Columbia",
    parent: "US"
  },
  "US-DE": {
    code: "US-DE",
    division: "state",
    lat: 38.9108325,
    lng: -75.52766989999998,
    name: "Delaware",
    parent: "US"
  },
  "US-FL": {
    code: "US-FL",
    division: "state",
    lat: 27.6648274,
    lng: -81.51575350000002,
    name: "Florida",
    parent: "US"
  },
  "US-GA": {
    code: "US-GA",
    division: "state",
    lat: 32.1574351,
    lng: -82.90712300000001,
    name: "Georgia",
    parent: "US"
  },
  "US-GU": {
    code: "US-GU",
    division: "outlying area",
    lat: 13.4666808,
    lng: 144.74546850000002,
    name: "Guam",
    parent: "US"
  },
  "US-HI": {
    code: "US-HI",
    division: "state",
    lat: 19.8967662,
    lng: -155.58278180000002,
    name: "Hawaii",
    parent: "US"
  },
  "US-IA": {
    code: "US-IA",
    division: "state",
    lat: 41.6624604,
    lng: -92.06651970000001,
    name: "Iowa",
    parent: "US"
  },
  "US-ID": {
    code: "US-ID",
    division: "state",
    lat: 45.9019541,
    lng: -115.7237432,
    name: "Idaho",
    parent: "US"
  },
  "US-IL": {
    code: "US-IL",
    division: "state",
    lat: 40.6331249,
    lng: -89.39852830000001,
    name: "Illinois",
    parent: "US"
  },
  "US-IN": {
    code: "US-IN",
    division: "state",
    lat: 40.5512165,
    lng: -85.60236429999998,
    name: "Indiana",
    parent: "US"
  },
  "US-KS": {
    code: "US-KS",
    division: "state",
    lat: 39.011902,
    lng: -98.48424649999998,
    name: "Kansas",
    parent: "US"
  },
  "US-KY": {
    code: "US-KY",
    division: "state",
    lat: 37.8393332,
    lng: -84.27001789999997,
    name: "Kentucky",
    parent: "US"
  },
  "US-LA": {
    code: "US-LA",
    division: "state",
    lat: 31.2448234,
    lng: -92.14502449999998,
    name: "Louisiana",
    parent: "US"
  },
  "US-MA": {
    code: "US-MA",
    division: "state",
    lat: 42.4072107,
    lng: -71.38243740000001,
    name: "Massachusetts",
    parent: "US"
  },
  "US-MD": {
    code: "US-MD",
    division: "state",
    lat: 39.0457549,
    lng: -76.6412712,
    name: "Maryland",
    parent: "US"
  },
  "US-ME": {
    code: "US-ME",
    division: "state",
    lat: 46.82,
    lng: -67.92361,
    name: "Maine",
    parent: "US"
  },
  "US-MI": {
    code: "US-MI",
    division: "state",
    lat: 42.3288623,
    lng: -83.12066649999997,
    name: "Michigan",
    parent: "US"
  },
  "US-MN": {
    code: "US-MN",
    division: "state",
    lat: 46.729553,
    lng: -94.68589980000002,
    name: "Minnesota",
    parent: "US"
  },
  "US-MO": {
    code: "US-MO",
    division: "state",
    lat: 37.9642529,
    lng: -91.8318334,
    name: "Missouri",
    parent: "US"
  },
  "US-MP": {
    code: "US-MP",
    division: "outlying area",
    lat: 15.2186754,
    lng: 145.7302138,
    name: "Northern Mariana Islands",
    parent: "US"
  },
  "US-MS": {
    code: "US-MS",
    division: "state",
    lat: 32.3546679,
    lng: -89.39852830000001,
    name: "Mississippi",
    parent: "US"
  },
  "US-MT": {
    code: "US-MT",
    division: "state",
    lat: 46.8796822,
    lng: -110.36256579999997,
    name: "Montana",
    parent: "US"
  },
  "US-NC": {
    code: "US-NC",
    division: "state",
    lat: 35.7595731,
    lng: -79.01929970000003,
    name: "North Carolina",
    parent: "US"
  },
  "US-ND": {
    code: "US-ND",
    division: "state",
    lat: 47.5514926,
    lng: -101.00201190000001,
    name: "North Dakota",
    parent: "US"
  },
  "US-NE": {
    code: "US-NE",
    division: "state",
    lat: 41.4925374,
    lng: -99.90181310000003,
    name: "Nebraska",
    parent: "US"
  },
  "US-NH": {
    code: "US-NH",
    division: "state",
    lat: 43.1938516,
    lng: -71.57239529999998,
    name: "New Hampshire",
    parent: "US"
  },
  "US-NJ": {
    code: "US-NJ",
    division: "state",
    lat: 40.0583238,
    lng: -74.4056612,
    name: "New Jersey",
    parent: "US"
  },
  "US-NM": {
    code: "US-NM",
    division: "state",
    lat: 34.9727305,
    lng: -105.03236349999997,
    name: "New Mexico",
    parent: "US"
  },
  "US-NV": {
    code: "US-NV",
    division: "state",
    lat: 38.8026097,
    lng: -116.41938900000002,
    name: "Nevada",
    parent: "US"
  },
  "US-NY": {
    code: "US-NY",
    division: "state",
    lat: 40.7143528,
    lng: -74.0059731,
    name: "New York",
    parent: "US"
  },
  "US-OH": {
    code: "US-OH",
    division: "state",
    lat: 38.6257264,
    lng: -82.23659809999998,
    name: "Ohio",
    parent: "US"
  },
  "US-OK": {
    code: "US-OK",
    division: "state",
    lat: 35.4675602,
    lng: -97.51642759999999,
    name: "Oklahoma",
    parent: "US"
  },
  "US-OR": {
    code: "US-OR",
    division: "state",
    lat: 43.8041334,
    lng: -120.55420119999997,
    name: "Oregon",
    parent: "US"
  },
  "US-PA": {
    code: "US-PA",
    division: "state",
    lat: 41.2033216,
    lng: -77.19452469999999,
    name: "Pennsylvania",
    parent: "US"
  },
  "US-PR": {
    code: "US-PR",
    division: "outlying area",
    lat: 31.75012,
    lng: -106.48776099999998,
    name: "Puerto Rico",
    parent: "US"
  },
  "US-RI": {
    code: "US-RI",
    division: "state",
    lat: 41.5800945,
    lng: -71.4774291,
    name: "Rhode Island",
    parent: "US"
  },
  "US-SC": {
    code: "US-SC",
    division: "state",
    lat: 33.836081,
    lng: -81.1637245,
    name: "South Carolina",
    parent: "US"
  },
  "US-SD": {
    code: "US-SD",
    division: "state",
    lat: 43.9695148,
    lng: -99.90181310000003,
    name: "South Dakota",
    parent: "US"
  },
  "US-TN": {
    code: "US-TN",
    division: "state",
    lat: 35.5174913,
    lng: -86.5804473,
    name: "Tennessee",
    parent: "US"
  },
  "US-TX": {
    code: "US-TX",
    division: "state",
    lat: 31.9685988,
    lng: -99.90181310000003,
    name: "Texas",
    parent: "US"
  },
  "US-UM": {
    code: "US-UM",
    division: "outlying area",
    lat: 19.295374,
    lng: 166.6280441,
    name: "United States Minor Outlying Islands",
    parent: "US"
  },
  "US-UT": {
    code: "US-UT",
    division: "state",
    lat: 39.3209801,
    lng: -111.09373110000001,
    name: "Utah",
    parent: "US"
  },
  "US-VA": {
    code: "US-VA",
    division: "state",
    lat: 37.4315734,
    lng: -78.65689420000001,
    name: "Virginia",
    parent: "US"
  },
  "US-VI": {
    code: "US-VI",
    division: "outlying area",
    lat: 18.3404431,
    lng: -64.917126,
    name: "Virgin Islands",
    parent: "US"
  },
  "US-VT": {
    code: "US-VT",
    division: "state",
    lat: 44.5588028,
    lng: -72.57784149999998,
    name: "Vermont",
    parent: "US"
  },
  "US-WA": {
    code: "US-WA",
    division: "state",
    lat: 47.7510741,
    lng: -120.74013860000002,
    name: "Washington",
    parent: "US"
  },
  "US-WI": {
    code: "US-WI",
    division: "state",
    lat: 43.7844397,
    lng: -88.78786780000001,
    name: "Wisconsin",
    parent: "US"
  },
  "US-WV": {
    code: "US-WV",
    division: "state",
    lat: 38.5976262,
    lng: -80.45490259999997,
    name: "West Virginia",
    parent: "US"
  },
  "US-WY": {
    code: "US-WY",
    division: "state",
    lat: 41.4774748,
    lng: -105.63665679999997,
    name: "Wyoming",
    parent: "US"
  }
}

export type ISO3166_2 = keyof typeof iso3166_2ToCoordinates

export const SegmentTypeToIcon = {
  device: IconName.DEVICES,
  geolocation: IconName.GLOBE,
  network: IconName.NETWORK,
  protocol: IconName.PROTOCOL,
  root: IconName.ALL_VIEWERS
} as const

export const NameLengthLimit = 100
